<template>
  <form class="form-group" @submit.prevent="handleSubmit" ref="formRef">
      <label for="name">Nom du pays *</label>
      <input
        v-model="localData.name"
        type="text"
        id="name"
        placeholder="Ex: France"
        required
      />
      <label for="code">Code ISO *</label>
      <input
        v-model="localData.code"
        type="text"
        id="code"
        placeholder="Ex: CMR"
        maxlength="3"
        pattern="[A-Z]{3}"
        title="Code ISO 3 lettres majuscules (ex: CMR, FRA, USA)"
        required
      />
      <label for="phoneCode">Indicatif téléphonique</label>
      <input
        v-model="localData.phoneCode"
        type="text"
        id="phoneCode"
        placeholder="Ex: +33"
        pattern="^\+?[0-9]{1,4}$"
        title="Indicatif téléphonique (ex: +33, +1, +41)"
      />
      <label for="currency">Devise</label>
      <input
        v-model="localData.currency"
        type="text"
        id="currency"
        placeholder="Ex: EUR"
        maxlength="3"
        pattern="[A-Z]{3}"
        title="Code devise ISO 4217 (ex: EUR, XAF, USD)"
      />
      <label for="exchangeRate">Taux de change</label>
      <input
        v-model.number="localData.exchangeRate"
        type="number"
        id="exchangeRate"
        min="0"
        step="0.000001"
        placeholder="Ex: 0.001524"
      />
    <div v-if="error" class="error-message">{{ error }}</div>
  </form>
</template>

<script setup>
import { ref, watch } from 'vue'

const props = defineProps({
  formData: { type: Object, default: () => ({ name: '', code: '', phoneCode: '', currency: '', exchangeRate: null }) }
})

const emit = defineEmits(['submit', 'cancel'])

const formRef = ref(null)
const error = ref('')

const localData = ref({
  name: props.formData?.name || '',
  code: props.formData?.code || '',
  phoneCode: props.formData?.phoneCode || '',
  currency: props.formData?.currency || '',
  exchangeRate: props.formData?.exchangeRate ?? null
})

watch(() => props.formData, (newFormData) => {
  if (newFormData) {
    localData.value = {
      name: newFormData.name || '',
      code: newFormData.code || '',
      phoneCode: newFormData.phoneCode || '',
      currency: newFormData.currency || '',
      exchangeRate: newFormData.exchangeRate ?? null
    }
  }
}, { deep: true })

const handleSubmit = () => {
  error.value = ''

  if (!formRef.value?.checkValidity()) {
    formRef.value?.reportValidity()
    return
  }

  // Normaliser le code en majuscules
  localData.value.code = localData.value.code.toUpperCase()
  localData.value.currency = localData.value.currency?.toUpperCase?.() || ''

  emit('submit', { ...localData.value })
}

defineExpose({ handleSubmit })
</script>
